/**
 * LinkButton Component
 * 재사용 가능한 링크 스타일 버튼 (도움말, 계정 신청 등)
 */
import React from "react";

interface LinkButtonProps {
    onClick: () => void;
    icon?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    style?: React.CSSProperties;
}

const LinkButton: React.FC<LinkButtonProps> = ({
    onClick,
    icon,
    children,
    className = '',
    style,
}) => {
    return (
        <button
            onClick={onClick}
            className={`help-link ${className}`}
            style={style}
        >
            {icon}
            {children}
        </button>
    );
};

export default LinkButton;
